<search-place [map]="map" id="workspace-area-search"></search-place>
<div #workspaceMiniMap id="workspace-mini-map" class="mini-map"></div>
